export enum TClientType {
	'Recipient' = 'Recipient',
	'Sender' = 'Sender',
	'Payer' = 'Payer'
}

export interface IClient {
	id: string;
	inn: string;
	name: string;
}
